import {
  pointerWithin,
  rectIntersection,
  closestCenter,
  type CollisionDetection,
} from "@dnd-kit/core";
import { formulaDropAreaId } from "./FormulaEditor.types";

export const formulaCollisionDetection: CollisionDetection = (args) => {
  const pointerHits = pointerWithin(args);
  const pointerOrRectHits =
    pointerHits.length > 0 ? pointerHits : rectIntersection(args);

  // 1. Chip under the cursor wins.
  const chipHits = pointerOrRectHits.filter((c) => c.id !== formulaDropAreaId);
  if (chipHits.length > 0) return chipHits;

  // Outside the drop area entirely (e.g. over the palette/footer): no target,
  // so a drop "to nowhere" cancels instead of mutating the formula.
  const overDropArea = pointerOrRectHits.some(
    (c) => c.id === formulaDropAreaId,
  );
  if (!overDropArea) return [];

  // 2. In a gap between chips: snap to the nearest chip.
  const nearestChip = closestCenter(args).filter(
    (c) => c.id !== formulaDropAreaId,
  );
  if (nearestChip.length > 0) return nearestChip;

  // 3. No chips at all: fall back to the drop area.
  return pointerOrRectHits;
};
